import React, { useState } from "react";
import { connect } from "react-redux";

import { CloseIcon, getProduktInfoIcon } from "../../utils/components/icons";
import { scrollToTop, formatCurrency, formatNumber } from "../../utils/functions";
import { Tooltip } from "../../utils/components/Tooltip";

export const SortenOrder = connect(store => {
  return {
    configStorage: store.configStorage
  };
})((props) => {
  const { warenkorbPos, configStorage, handleRemark } = props || {};
  const headers = [
    "Produkt",
    "Kurs",
    "Betrag",
    "Stückelung",
    "Gegenwert inkl. Konditionsänderung/Gebühr"
  ];
  const [warenkorbItem, setWarenkorbItem] = useState();

  const stueckelung = () => {
    if (!warenkorbItem || !warenkorbItem.stueckelung || !warenkorbItem.betragStueckelung) return null;
    let stueckelungArray = warenkorbItem.stueckelung.split(",");
    let betragArray = warenkorbItem.betragStueckelung.split(",");
    let iso = warenkorbItem.iso;
    return <table className="fs-4 stueckelung">
      <tbody>
        {stueckelungArray.map((wert, i) => {
          let bet = betragArray[i];
          let count = Math.floor(Number(bet) / Number(wert));
          if (count === 0) return null;
          return (
            <tr key={"stueckelung" + wert}>
              <td className="text-end">{count}</td>
              <td>{wert} {iso} Note{count !== 1 ? "n" : ""}:</td>
              <td>{formatCurrency(bet, iso)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>;
  };

  const renderStueckelung = (data) => {
    return data.stueckelung !== ""
      ? (
        <div>
          <button
            id="admin-btn"
            className="btn btn-link fs-5"
            data-bs-toggle="modal"
            data-bs-target="#flipFlop"
            onClick={() => {
              setWarenkorbItem(data);
              if (configStorage.isVerseNeo()) {
                scrollToTop();
              }
            }}
          >
            ansehen
          </button>
          <div
            className="modal fade"
            id="flipFlop"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="modalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h2
                    className="modal-title text-primary"
                    id="modalLabel"
                  >
                    Stückelung
                  </h2>
                  <button
                    type="button"
                    className="btn btn-default ser-close-modal"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <CloseIcon></CloseIcon>
                  </button>
                </div>
                <div className="modal-body">
                  <h4 className="text-gray">
                    <span className="fw-bold">Hinweis:</span> Die
                    Währungsbeträge werden unten aufgelistet, nicht die
                    Anzahl der Banknoten.
                  </h4>
                  <hr />
                  <h3>{data.currencyname}</h3>
                  {stueckelung()}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Schließen
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
      : (
        "gemischt"
      );
  };

  const renderOrder = (warenkorbPos) => {
    if (!Array.isArray(warenkorbPos)) {
      return <tr><td>Loading...</td></tr>;
    }

    return warenkorbPos.map((data, index) => {
      let row = (
        <tr key={data.id || index}>
          <td
            className="text-center col-lg-2"
          >
            <img
              alt="Bild"
              src={configStorage.getImgUrl(data.image)}
              className="ms-1 border border-color-dark small-image"
            />
          </td>
          <td
            className="col-lg-2"
            aria-label={headers[0]}
          >
            <span>{data.name}</span>
            <Tooltip icon={getProduktInfoIcon()}>{data.produktInfo}</Tooltip>
          </td>
          <td
            className="text-end col-lg-2"
            aria-label={headers[1]}
          >
            {formatNumber(data.rate, {
              minimumFractionDigits: 0,
              maximumFractionDigits: 3
            })}
          </td>
          <td
            className="text-end col-lg-2"
            aria-label={headers[2]}
          >
            {formatCurrency(data.fremdwaehrung, data.iso)}
          </td>
          <td
            className="text-center col-lg-2"
            aria-label={headers[3]}
          >
            {renderStueckelung(data)}
          </td>
          <td
            className="text-end col-lg-2"
            aria-label={headers[4]}
          >
            {formatCurrency(data.brutto)}
          </td>
        </tr>
      );
      if (configStorage.isMaShop()) {
        row = [row, (
          <tr key={"row2_" + data.id} className="form-group">
            <td className="text-md-end">
              <label
                htmlFor="bemerkung"
                className="fs-5"
              >
                Bemerkung:
              </label>
            </td>
            <td colSpan="5">
              <input
                type="text"
                name="bemerkung"
                className="form-control"
                maxLength="55"
                placeholder={"Bemerkung zur Bestellung von " + data.fremdwaehrung + " " + data.iso}
                aria-label={"Bemerkung zur Bestellung von " + data.fremdwaehrung + " " + data.iso}
                onChange={e => {
                  if (typeof handleRemark === "function")
                    handleRemark(e, index);
                }}
              />
            </td>
          </tr>
        )];
      }
      return row;
    });
  };

  return (
    <div className="table-responsive table-scroll ser-table">
      <table className="col-12 order-detail table table-responsive table-striped">
        <thead>
          <tr
            className="gray-500 fs-5 fw-bold"
          >
            <th className="col-12 col-lg-2"><div className="aria-visible">Bild</div></th>
            {headers.map((name, index) => {
              return (
                <th key={"header" + index} className="col-12 col-lg-2 text-center">
                  {name}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className="well">
          {renderOrder(warenkorbPos)}
        </tbody>
      </table>
    </div>
  );
});
